<template lang="html">
	<div class="mute-toggle">
		<div class="icon-wrapper">
				<img src="../assets/images/Icon/Mute/Dark.svg" v-if="applyWarningColors"  alt="Sound is off" class="icon">
				<img src="../assets/images/Icon/Mute/Main.svg" v-else alt="Sound is off" class="icon">
		</div>
		<button
  		key="unmute"
  		aria-label="Enable sound"
  		class="button with-label"
			:class="applyWarningColors ? 'secondary-dark' : 'secondary-primary'"
			@touchend.stop="$emit('unmute')"
  		@click.stop="$emit('unmute')"
		>
      Enable sound
    </button>
	</div>
</template>

<script>
export default {
  name: "ToggleMute",

	props:{
		applyWarningColors : {
			type: Boolean,
			required: true
		},
	}
}
</script>

<style scoped lang="scss">

@import '../style/abstracts/variables.scss';
@import '../style/abstracts/functions.scss';
@import '../style/abstracts/mixins.scss';

.mute-toggle {
	margin-top: 20vh;
	margin-top: calc(env(safe-area-inset-top) + 20vh); // Includes iPhone X safe area
	width: 100%;
	height: $default+rem;
	display: grid;
	grid-template-areas: ". icon button . .";
	grid-template-columns: 1fr $default+rem auto $default+rem 1fr;
	grid-gap: $medium+rem;

	@media screen and (orientation:landscape){
		margin-top: 1.5*$large+rem;
		margin-top: calc(env(safe-area-inset-top) + #{5*$large+px}); // Includes iPhone X safe area
	}

	.icon-wrapper {
		grid-area: icon;
    display: flex;
    justify-content: center;
	}
	.icon{
		position: relative; // for z-index
	}
	.button {
		grid-area: button;
	}
}
</style>



// WEBPACK FOOTER //
// src/components/ToggleMute.vue